'use client';

import Link from 'next/link';
import LegacyProfileFillIcon from 'src/app/_components/icons/legacy/LegacyProfileFillIcon';
import { useCurrentPath } from 'src/hooks/useCurrentPath';
import { useAppSelector } from 'src/store/client/config';

import MenuItem from './MenuItem';

// 메인 드로어 컴포넌트
const MenuDrawer = ({ isOpen }: { isOpen: boolean }) => {
  const currentPath = useCurrentPath();
  const { LoggedIn: isLoggedIn } = useAppSelector((state) => state.user);

  // 메뉴 아이템 데이터
  const menuItems = [
    { pathname: '/originals', label: 'ORIGINALS' },
    { pathname: '/event', label: 'EVENT' },
    {
      pathname: '#',
      label: 'SUPPORT',
      subMenuList: [
        { pathname: '/support/notice/list', label: 'NOTICE' },
        { pathname: '/support/faq/list', label: 'FAQ' },
        { pathname: '/support/qna/list', label: '1:1 문의' },
        { pathname: '/notion-app/guide/main', label: 'GUIDE' },
        { pathname: '/story', label: 'STORY' },
      ],
    },
  ];

  return (
    <div
      className={`absolute top-[56px] z-[9] h-[calc(100vh-56px)] w-full overflow-hidden overflow-y-auto bg-white text-left transition-[height] duration-300 ${
        isOpen ? 'block' : 'hidden'
      }`}
    >
      <ul>
        <li className="relative border-b border-[#D6D6D6]">
          {isLoggedIn ? (
            <div className="relative flex items-center justify-between px-[30px] py-[17px] text-lg leading-normal font-extrabold">
              <div className="flex items-center gap-[10px]">
                <LegacyProfileFillIcon background="#000000" size={30} />
                <Link href="/mypage" className="text-lg leading-normal font-extrabold text-[#121212]">
                  MY
                </Link>
              </div>
              <Link
                href={{
                  pathname: '/account/logout',
                  query: {
                    retUrl: currentPath,
                  },
                }}
                className="text-base leading-normal font-medium text-[#B2B2B2]"
              >
                LOGOUT
              </Link>
            </div>
          ) : (
            <Link
              href={{ pathname: '/account/login', query: { retUrl: currentPath } }}
              className="relative flex px-[30px] py-[17px] text-lg leading-normal font-extrabold"
            >
              LOGIN
            </Link>
          )}
        </li>

        {menuItems.map((item) => (
          <MenuItem key={item.pathname} {...item} />
        ))}
      </ul>
    </div>
  );
};

export default MenuDrawer;
